import { axiosInstance } from "@/api/axiosInstance";

const BASE = "/admin/admins";

// Drops empty filters so they are not sent as "active=" etc.
const cleanParams = (params) =>
    Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== "")
    );

const request = async (label, call) => {
    try {
        const response = await call();
        return response.data;
    } catch (error) {
        console.error(`Error ${label}:`, error.message);
        throw error;
    }
};

export const adminsService = {
    getAdmins: (page = 0, size = 10, { search, active } = {}) =>
        request("fetching admins", () =>
            axiosInstance.get(BASE, { params: cleanParams({ page, size, search, active }) })
        ),

    getAdminById: (id) => request(`fetching admin ${id}`, () => axiosInstance.get(`${BASE}/${id}`)),

    createAdmin: (payload) => request("creating admin", () => axiosInstance.post(BASE, payload)),

    updatePermissions: (id, { fullAccess, permissions }) =>
        request(`updating permissions of admin ${id}`, () =>
            axiosInstance.put(`${BASE}/${id}/permissions`, { fullAccess, permissions: fullAccess ? [] : permissions })
        ),

    deactivateAdmin: (id) => request(`deactivating admin ${id}`, () => axiosInstance.patch(`${BASE}/${id}/deactivate`)),

    activateAdmin: (id) => request(`activating admin ${id}`, () => axiosInstance.patch(`${BASE}/${id}/activate`)),

    resetPassword: (id) => request(`resetting password of admin ${id}`, () => axiosInstance.post(`${BASE}/${id}/reset-password`)),

    getMe: () => request("fetching my permissions", () => axiosInstance.get(`${BASE}/me`)),

    getPermissions: () => request("fetching permissions", () => axiosInstance.get(`${BASE}/permissions`)),

    getActivity: (page = 0, size = 20, { adminId, section, type, from, to, search } = {}) =>
        request("fetching activity", () =>
            axiosInstance.get(`${BASE}/activity`, {
                params: cleanParams({ page, size, adminId, section, type, from, to, search }),
            })
        ),

    getAdminActivity: (id, page = 0, size = 20, { section, type, from, to, search } = {}) =>
        request(`fetching activity of admin ${id}`, () =>
            axiosInstance.get(`${BASE}/${id}/activity`, {
                params: cleanParams({ page, size, section, type, from, to, search }),
            })
        ),
};

export const ACTIVITY_TYPES = ["LOGIN", "CHANGE", "DOWNLOAD"];